module.exports = __webpack_public_path__ + "static/media/moscow.22b270ac.md";